export interface Message {
  id: string;
  text: string;
  sender: "user" | "team";
  timestamp: number;
  isRead?: boolean;
}

export interface Chat {
  id: string;
  userName: string;
  userEmail: string;
  accountNumber?: string;
  messages: Message[];
  lastActivity: number;
  isActive: boolean;
  status: "active" | "closed" | "waiting" | "new";
  assignedTo?: string;
  isTyping?: boolean;
  ipAddress?: string;
  country?: string;
  priority_level?: "low" | "medium" | "high";
}

export interface CannedResponse {
  id: string;
  title: string;
  text: string;
  category: string;
  createdBy: string;
  isTeamResponse: boolean;
  createdAt: number;
  colorScheme: string;
}

export interface TeamChatPanelProps {
  onTransferChat?: () => void;
}

export const colorSchemes = [
  { bg: "bg-blue-50", border: "border-blue-200", text: "text-blue-800" },
  { bg: "bg-green-50", border: "border-green-200", text: "text-green-800" },
  { bg: "bg-yellow-50", border: "border-yellow-200", text: "text-yellow-800" },
  { bg: "bg-purple-50", border: "border-purple-200", text: "text-purple-800" },
  { bg: "bg-pink-50", border: "border-pink-200", text: "text-pink-800" },
  { bg: "bg-orange-50", border: "border-orange-200", text: "text-orange-800" },
  { bg: "bg-indigo-50", border: "border-indigo-200", text: "text-indigo-800" },
];

export const defaultCategories = [
  "General",
  "Account Issues",
  "Deposits",
  "Withdrawals",
  "Trading",
  "Technical Support",
  "Verification"
];

export const DefaultCannedResponses: CannedResponse[] = [
  {
    id: "cr1",
    title: "Welcome",
    text: "Welcome to FXnity Support! How can I assist you today with your trading account?",
    category: "General",
    createdBy: "System",
    isTeamResponse: true,
    createdAt: Date.now() - 1000000,
    colorScheme: "bg-blue-50 border-blue-200 text-blue-800"
  },
  {
    id: "cr2",
    title: "Deposit Info",
    text: "To make a deposit, please go to your account dashboard and select 'Deposit' from the menu. We accept credit/debit cards, bank transfers, and several e-wallets.",
    category: "Deposits",
    createdBy: "System",
    isTeamResponse: true,
    createdAt: Date.now() - 900000,
    colorScheme: "bg-green-50 border-green-200 text-green-800"
  },
  {
    id: "cr3",
    title: "Withdrawal Process",
    text: "Withdrawals are processed within 1-2 business days. Please note that funds will be returned to the same payment method used for the deposit.",
    category: "Withdrawals",
    createdBy: "System",
    isTeamResponse: true,
    createdAt: Date.now() - 800000,
    colorScheme: "bg-yellow-50 border-yellow-200 text-yellow-800"
  },
  {
    id: "cr4",
    title: "Account Verification",
    text: "For account verification, please submit your ID (passport or driver's license) and a recent utility bill or bank statement (not older than 3 months).",
    category: "Verification",
    createdBy: "System",
    isTeamResponse: true,
    createdAt: Date.now() - 700000,
    colorScheme: "bg-purple-50 border-purple-200 text-purple-800"
  },
  {
    id: "cr5",
    title: "Trading Hours",
    text: "Our trading hours follow the global market schedule. Forex is available 24/5 (Sunday 10PM - Friday 5PM UTC). Stocks and indices follow their respective exchange hours.",
    category: "Trading",
    createdBy: "System",
    isTeamResponse: true,
    createdAt: Date.now() - 600000,
    colorScheme: "bg-pink-50 border-pink-200 text-pink-800"
  },
  {
    id: "cr6",
    title: "Technical Support",
    text: "If you're experiencing technical issues with the platform, please try clearing your browser cache, disabling extensions, or using our desktop application. For further assistance, please provide us with details of the issue.",
    category: "Technical Support",
    createdBy: "System",
    isTeamResponse: true,
    createdAt: Date.now() - 500000,
    colorScheme: "bg-orange-50 border-orange-200 text-orange-800"
  },
  {
    id: "cr7",
    title: "Account Issues",
    text: "If you're having trouble accessing your account, you can reset your password through the login page. If problems persist, please provide us with your registered email address so we can investigate further.",
    category: "Account Issues",
    createdBy: "System",
    isTeamResponse: true,
    createdAt: Date.now() - 400000,
    colorScheme: "bg-indigo-50 border-indigo-200 text-indigo-800"
  }
];
